module.exports = {"title":"Tous les articles","desc":"Liste de toutes les actualités de la maison d'édition 'les fabulantes'"}